import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { Row } from "@faire/web--source/slate/Layout";
import { getSlateIcon } from "@faire/web--source/slate/SlateMappings/getSlateIcon";
import { NoTranslate } from "@faire/web--source/ui/lib/localization";
import { IFaireIcon } from "@faire/web-api--source/indigofair/data/IFaireIcon";
import classNames from "classnames";
import React from "react";

import { LoadableTypography } from "@faire/retailer/components/GhostLoading/LoadableTypography";

import * as styles from "./brandNameText.css";

interface IBrandNameTextProps {
  brandToken: string | undefined;
  brandName: string | undefined;
  brandIcon?: IFaireIcon | undefined;
  isLoaded: boolean;
  // If true, the brand name will be wrapped in a link
  // if false, the brand name will not be wrapped in a link, used when
  //  setting PRICE_FIRST_AND_NEW_BRAND_LINK_ON_SEARCH_TILE_241029 is
  //  set to NEW_BRAND_LINK
  withLink?: boolean;
}

export const BrandNameText: React.FC<IBrandNameTextProps> = ({
  brandToken,
  brandName,
  brandIcon,
  isLoaded,
  withLink = true,
}) => {
  const BrandIcon = getSlateIcon(brandIcon);

  const brandNameSection = (
    <Row align="center" gap="1/4x">
      {brandIcon ? (
        <BrandIcon
          fontSize="12px"
          color={getSlateColorToken(brandIcon.color_token)}
          titleAccess=""
        />
      ) : null}
      <LoadableTypography
        isLoaded={isLoaded}
        variant={!withLink ? "paragraphSansMedium" : "paragraphSansRegular"}
        maxLines={1}
      >
        <NoTranslate>
          <span
            className={classNames(!withLink ? styles.hoverMakerName : null)}
          >
            {brandName}
          </span>
        </NoTranslate>
      </LoadableTypography>
    </Row>
  );

  if (!brandToken) {
    return null;
  }
  return (
    <Row
      className={classNames(!withLink ? null : styles.makerName)}
      justify="space-between"
    >
      {brandNameSection}
    </Row>
  );
};
